module.exports = __webpack_public_path__ + "img/Streeme/Streeme-favicon-32x32.png";